<!-- src/layouts/DefaultLayout.vue -->
<template>
  <div>
    <Navbar />
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <Sidebar />
    <main class="app-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import $ from 'jquery';

import Navbar from '@/components/Navbar.vue';
import Sidebar from '@/components/Sidebar.vue';

export default {
  name: 'DefaultLayout',
  components: {
    Navbar,
    Sidebar
  },
  mounted() {
    var treeviewMenu = $('.app-menu');

    // Toggle Sidebar
    $('[data-toggle="sidebar"]').click(function (event) {
      event.preventDefault();
      $('.app').toggleClass('sidenav-toggled');
    });

    // Activate sidebar treeview toggle
    $("[data-toggle='treeview']").click(function (event) {
      event.preventDefault();
      if (!$(this).parent().hasClass('is-expanded')) {
        treeviewMenu.find("[data-toggle='treeview']").parent().removeClass('is-expanded');
      }
      $(this).parent().toggleClass('is-expanded');
    });
  },
};
</script>

<style scoped>
/* Add your styles here */
/* .app-container {
    display: flex;
  }
  .app-content-wrapper {
    flex: 1;
  } */
</style>